import React, { ReactNode, useEffect, useState } from "react";
import classNames from "classnames";
import PopupCloseButton from "@/features/common/popupCloseButton/PopupCloseButton";
import {
  MARKETING_POPUP_CLOSE_DELAY_MS,
  shouldRenderMarketingPopupCloseButton,
} from "./closeButton";
import styles from "./MarketingImagePopup.module.less";

interface MarketingImagePopupProps {
  imageSrc: string;
  imageAlt: string;
  onImageClick?: () => void;
  onClose?: () => void;
  showCloseButton?: boolean;
  footer?: ReactNode;
  imageOverlay?: ReactNode;
  className?: string;
  imageClassName?: string;
  footerClassName?: string;
}

const MarketingImagePopup: React.FC<MarketingImagePopupProps> = ({
  imageSrc,
  imageAlt,
  onImageClick,
  onClose,
  showCloseButton = true,
  footer,
  imageOverlay,
  className,
  imageClassName,
  footerClassName,
}) => {
  const hasFooter = Boolean(footer);
  const [closeButtonReady, setCloseButtonReady] = useState(false);

  useEffect(() => {
    setCloseButtonReady(false);

    if (!showCloseButton) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setCloseButtonReady(true);
    }, MARKETING_POPUP_CLOSE_DELAY_MS);

    return () => {
      window.clearTimeout(timer);
    };
  }, [showCloseButton, imageSrc]);

  return (
    <div
      className={classNames(styles.container, className, {
        [styles.withFooter]: hasFooter,
      })}
    >
      {onClose &&
        shouldRenderMarketingPopupCloseButton({
          showCloseButton,
          closeButtonReady,
        }) && <PopupCloseButton onClose={onClose} />}
      <div className={styles.imageWrap}>
        <img
          src={imageSrc}
          alt={imageAlt}
          className={classNames(styles.image, imageClassName)}
          onClick={onImageClick}
        />
        {imageOverlay && (
          <div className={styles.imageOverlay}>{imageOverlay}</div>
        )}
      </div>
      {footer && (
        <div className={classNames(styles.footer, footerClassName)}>
          {footer}
        </div>
      )}
    </div>
  );
};

export default MarketingImagePopup;
